import { useState, useEffect, useContext, memo } from 'react';
import { useLocation, useNavigate, Link, Outlet } from 'react-router-dom';
// store
import { useSelector, useDispatch,
  SET_RANGES_LOCATION_SENSORS, DELETE_RANGES_LOCATION_SENSORS,
  SET_RANGES_LOCATION_PREDICTIONS, DELETE_RANGES_LOCATION_PREDICTIONS,
  SET_RANGES_SENSOR, DELETE_RANGES_SENSOR,
  SET_RANGES_RECENTLY_SENSOR, DELETE_RANGES_RECENTLY_SENSOR,
  SET_RANGES_ANALYSIS, DELETE_RANGES_ANALYSIS } from '../../store';
// hooks
import useResponsive from '../../hooks/useResponsive';
// sections
import GroupsField from './GroupsField';
import SettingsDialog from './SettingsDialog';
import SecurityDialog from './SecurityDialog';
import AlarmDialog from './AlarmDialog';
import Devices from './Devices';
// components
import Loaders from '../../components/loaders';
// @devextreme
import { Popover } from 'devextreme-react/popover';
// assets
import { ReactComponent as Account } from '../../assets/account/account.svg';
import { ReactComponent as Settings } from '../../assets/account/settings.svg';
import { ReactComponent as Password } from '../../assets/account/password.svg';
import { ReactComponent as AlarmSettings } from '../../assets/account/alarm.svg';
import { ReactComponent as Log } from '../../assets/account/log.svg';
import { ReactComponent as Logout } from '../../assets/account/logout.svg';
import { ReactComponent as GnbIcon } from '../../assets/nav/gnb.svg';
import { RealTime, Analysis, Inquiry, Alarm, Device, Member } from '../../assets/nav';
import { ReactComponent as CloseIcon } from '../../assets/button/close.svg';
// styles
import { ThemeContext } from 'styled-components';
import { Container, Header, AccountButton, AccountPopover, Wrapper, Nav, GnbLink, GnbButton, Lnb, Logo, Main, MobilePopover, Close, ScrollBar } from './styles';
// utils
import userAgent from '../../utils/user-agent';
import { timezones } from '../../utils/format';
// apis
import { getAccount, logout } from '../../apis';

// ----------------------------------------------------------------------

export default function Layout() {
  const dispatch = useDispatch();
  const mobile = useResponsive('down', 'md');

  const theme = useContext(ThemeContext);
  const config = {
    users: [
      { path: '/real-time', title: '실시간 현황', icon: <RealTime color={theme.colors.grayscale[mobile ? 800 : 100]} /> },
      { path: '/analysis', title: '통계 분석', icon: <Analysis color={theme.colors.grayscale[mobile ? 800 : 100]} /> },
      { path: '/inquiry', title: '데이터 조회', icon: <Inquiry color={theme.colors.grayscale[mobile ? 800 : 100]} /> },
      { path: '/alarm', title: '알람', icon: <Alarm color={theme.colors.grayscale[mobile ? 800 : 100]} /> }
    ],
    manager: {
      id: 'iot', title: 'IoT 장비 관리', icon: <Device color={theme.colors.grayscale[mobile ? 800 : 100]} />,
      children: [
        { path: '/status', title: 'IoT 장비 현황' },
        { path: '/groups', title: 'IoT 장비 그룹' },
        { path: '/devices', title: 'IoT 장비' },
        { path: '/sensor-model', title: '수질 센서 모델' }
      ]
    },
    admin: {
      id: 'accounts', title: '계정 관리', icon: <Member color={theme.colors.grayscale[mobile ? 800 : 100]} />,
      children: [
        { path: '/organizations', title: '조직' },
        { path: '/members', title: '사용자' },
        { path: '/login-logs', title: '로그인 조회' }
      ]
    }
  };

  const location  = useLocation();
  const pathname = location.pathname.split('/');
  const navigate = useNavigate();

  const loggedin = useSelector((state) => state.loggedin);
  const account = useSelector((state) => state.account);
  const loader = useSelector((state) => state.loader);
  const devices = useSelector((state) => state.devices);
    const rangesLocationSensors = useSelector((state) => state.rangesLocationSensors);
    const rangesLocationPredictions = useSelector((state) => state.rangesLocationPredictions);
    const rangesSensor = useSelector((state) => state.rangesSensor);
    const rangesRecentlySensor = useSelector((state) => state.rangesRecentlySensor);
    const rangesAnalysis = useSelector((state) => state.rangesAnalysis);

  useEffect(() => {
    if ( devices.length > 0 ) {
      handleRanges(devices);
    } else {
      dispatch( DELETE_RANGES_LOCATION_SENSORS() );
      dispatch( DELETE_RANGES_LOCATION_PREDICTIONS() );
      dispatch( DELETE_RANGES_SENSOR() );
      dispatch( DELETE_RANGES_RECENTLY_SENSOR() );
      dispatch( DELETE_RANGES_ANALYSIS() );
    }
  }, [devices]);

  const handleRanges = (response: any) => {
    const range: {[key: string]: any} = {};
    const sensors: {[key: string]: any} = {};
    const locationSensors: {[key: string]: any} = {};
    const locationPredictions: {[key: string]: any} = {};
    response.forEach((device: any) => {
      device.waterQualitySensors.forEach((sensor: any) => {
        sensors[sensor.name] = { manual: false, startValue: 0, endValue: 20 };
        range[sensor.waterQualitySensorId] = { manual: false, startValue: 0, endValue: 20 };
        locationSensors[sensor.waterQualitySensorId] = { manual: false, startValue: 0, endValue: 20 };
      });
      device.waterQualityPredictions.forEach((prediction: any) => {
        range[prediction.waterQualityPredictionId] = { manual: false, startValue: 0, endValue: 20 };
        sensors[prediction.name] = { manual: false, startValue: 0, endValue: 20 };
        locationPredictions[prediction.waterQualityPredictionId] = { manual: false, startValue: 0, endValue: 20 };
      });
    });
    dispatch(SET_RANGES_LOCATION_SENSORS({ ...rangesLocationSensors, ...locationSensors, waterTemperature: { manual: false, startValue: 0, endValue: 20 }}));
    dispatch(SET_RANGES_LOCATION_PREDICTIONS({ ...rangesLocationPredictions, ...locationPredictions }));
    dispatch(SET_RANGES_SENSOR({ ...rangesSensor, ...sensors, waterTemperature: { manual: false, startValue: 0, endValue: 20 }}));
    dispatch(SET_RANGES_RECENTLY_SENSOR({ ...rangesRecentlySensor, ...sensors, waterTemperature: { manual: false, startValue: 0, endValue: 20 }}));
    dispatch(SET_RANGES_ANALYSIS({ ...rangesAnalysis, ...sensors, waterTemperature: { manual: false, startValue: 0, endValue: 20 }}));
  };

  useEffect(() => {
    if ( location.state?.submit ) {
      const handleEvent = () => window.history.pushState(null, '', window.location.href);
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handleEvent);
      return () => window.removeEventListener('popstate', handleEvent);
    }
  }, [location]);

  useEffect(() => {
    if ( !loggedin ) {
      return navigate('/');
    } else if ( !account ) {
      ( async () =>
        await getAccount()
      )();
    }
  }, [loggedin, account]);

  useEffect(() => {
    if ( pathname.length > 2 ) {
      if ( account?.role == 'USER' ) return navigate(-1);
      if ( account?.role == 'MANAGER' && pathname[2] !== 'status' ) return navigate(-1);
    }
  }, [pathname]);

  const [ active, setActive ] = useState(true);
  const [ visible, setVisible ] = useState(false);
  const [ visibleGroup, setVisibleGroup ] = useState(false);

  const handleLogout = async () => {
    const UA = userAgent();
    await logout(UA);
  };

  const [ settings, setSettings ] = useState(false);
  const [ security, setSecurity ] = useState(false);
  const [ alarm, setAlarm ] = useState(false);
  
  if ( !loggedin || !account ) return;
  return (
    <Container>
      { loader &&
        <Loaders />
      }
      <Header $active={active}>
        <div>
          <button type='button' onClick={() => {
            if ( mobile && active ) {
              if ( visible ) setVisible(false);
              if ( visibleGroup ) setVisibleGroup(false);
            }
            setActive(!active);
          }}>
            <GnbIcon />
          </button>

          { pathname.length === 2 &&
            <GroupsField visible={visibleGroup} setVisible={setVisibleGroup} active={active} setActive={setActive} visibleAccount={visible} setVisibleAccount={setVisible} />
          }
        </div>

        <div>
          <AccountButton type='button' id='account' onClick={() => {
            if ( mobile && !visible ) {
              if ( !active ) setActive(true);
              if ( visibleGroup ) setVisibleGroup(false);
            }
            setVisible(!visible);
          }} $active={visible}>
            { !mobile &&
              <>
                <div>
                  <Account width={24} height={24} fill={theme.colors.grayscale[200]} />
                  <div>{ account?.identification }</div>
                  <span>님</span>
                </div>
                <div />
              </>
            }
          </AccountButton>
          { mobile ? (
            <MobilePopover $visible={visible}>
              <Close>
                <button type='button' onClick={() => setVisible(false)}><CloseIcon /></button>
              </Close>
              <AccountPopover>
                <div>
                  <Account width={24} height={24} fill={theme.colors.primary[300]} />
                  <p>{ account?.identification } <span>님</span></p>
                </div>
                <p>계정 만료일: {timezones(account.expirationAt, 'YYYY-MM-DD')}</p>
                <button type='button' onClick={() => {
                  setVisible(false);
                  setSettings(true)
                }}>
                  <Settings width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  계정 관리
                </button>
                <button type='button' onClick={() => {
                  setVisible(false);
                  setSecurity(true)
                }}>
                  <Password width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  보안 설정
                </button>
                <button type='button' onClick={() => {
                  setVisible(false);
                  setAlarm(true);
                }}>
                  <AlarmSettings width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  이메일 알람
                </button>
                <button type='button' onClick={() => {
                  setVisible(false);
                  navigate('/account');
                }}>
                  <Log width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  로그인 조회
                </button>
                <button type='button' onClick={handleLogout}>
                  <Logout width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  로그아웃
                </button>
              </AccountPopover>
            </MobilePopover>
          ) : (
            <Popover
              target='#account'
              visible={visible}
              hideOnOutsideClick={true}
              onHiding={() => setVisible(false)}
            >
              <AccountPopover>
                <div>
                  <Account width={24} height={24} fill={theme.colors.primary[300]} />
                  <p>{ account?.identification } <span>님</span></p>
                </div>
                <button type='button' onClick={() => {
                  setVisible(false);
                  setSettings(true)
                }}>
                  <Settings width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  계정 관리
                </button>
                <button type='button' onClick={() => {
                  setVisible(false);
                  setSecurity(true)
                }}>
                  <Password width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  보안 설정
                </button>
                <button type='button' onClick={() => {
                  setVisible(false);
                  setAlarm(true);
                }}>
                  <AlarmSettings width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  이메일 알람
                </button>
                <button type='button' onClick={() => {
                  setVisible(false);
                  navigate('/account');
                }}>
                  <Log width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  로그인 조회
                </button>
                <button type='button' onClick={handleLogout}>
                  <Logout width={16} height={16} stroke={theme.colors.grayscale[600]} />
                  로그아웃
                </button>
              </AccountPopover>
            </Popover>
          )}
        </div>
      </Header>

      <Wrapper>
        <Nav $active={active}>
          { mobile &&
            <Close>
              <button type='button' onClick={() => setActive(true)}><CloseIcon /></button>
            </Close>
          }

          <ScrollBar>
            { config.users.map((nav) => (
              <GnbLink key={nav.path} to={nav.path} $display={'/' + pathname[1] === nav.path ? true : false} $active={active} onClick={() => { if (mobile) setActive(true) }}>
                <div>
                  { nav.icon }
                  <p>{ nav.title }</p>
                </div>
              </GnbLink>
            ))}

            { (account?.role === 'MANAGER' || account?.role === 'ADMIN') &&
              <Gnb active={active} setActive={setActive} mobile={mobile} nav={config.manager} pathname={pathname[1]} subPath={pathname[2]} role={account?.role} />
            }

            { account?.role === 'ADMIN' &&
              <Gnb active={active} setActive={setActive} mobile={mobile} nav={config.admin} pathname={pathname[1]} subPath={pathname[2]} role={account?.role} />
            }
          </ScrollBar>

          <Logo $active={active} />
        </Nav>

        <Main $active={active}>
          { (pathname[1] === 'analysis' || pathname[1] === 'inquiry' || pathname[1] === 'alarm-settings') && !mobile &&
            <Devices active={active} />
          }
          <Outlet />
        </Main>

        { settings &&
          <SettingsDialog expirationAt={timezones(account.expirationAt, 'YYYY-MM-DD')} email={account.email} setVisible={setSettings} />
        }

        { security &&
          <SecurityDialog setVisible={setSecurity} />
        }

        { alarm &&
          <AlarmDialog receive={account.receiveAlarm} email={account.email} setVisible={setAlarm} />
        }
      </Wrapper>
    </Container>
  );
}

// ----------------------------------------------------------------------

interface Props {
  active: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>
  mobile: boolean;
  nav: {
    id: string;
    title: string;
    icon: JSX.Element;
    children: {
        path: string;
        title: string;
    }[];
  };
  pathname: string;
  subPath: any;
  role: string;
};

const Gnb = memo(({ active, setActive, mobile, nav, pathname, subPath, role }: Props) => {

  const [ visible, setVisible ] = useState(false);

  useEffect(() => {
    if ( !active && visible ) setVisible(false);
    // eslint-disable-next-line
  }, [active]);

  const render = (
    nav.children.map((item) => (
      <Link key={item.path} to={'/' + nav.id + item.path} onClick={() => { if (mobile) setActive(true) }} className={'/' + subPath === item.path ? 'active' : ''}>
        { item.title }
      </Link>
    ))
  );

  return (
    <>
      <GnbButton
        type='button'
        onClick={() => {setVisible(!visible)}}
        $visible={visible}
        $display={pathname === nav.id ? true : false}
        $active={active}
      >
        <div>
          <div id={nav.id}>{ nav.icon }</div>
          <p>{ nav.title }</p>
        </div>
      </GnbButton>

      { role === 'MANAGER' ? (
        active || mobile ? (
          <Lnb $visible={visible} $length={1}>
            <Link to='/iot/status' onClick={() => { if (mobile) setActive(true) }} className={subPath === 'status' ? 'active' : ''}>
              IoT 장비 현황
            </Link>
          </Lnb>
        ) : (
          <Popover
            target={`#${nav.id}`}
            visible={visible}
            hideOnOutsideClick={true}
            onHiding={() => setVisible(false)}
            position='right'
            wrapperAttr={{class: 'nav-popover'}}
          >
            <Link to='/status'>
              IoT 장비 현황
            </Link>
          </Popover>
        )
      ) : (
        active || mobile ? (
          <Lnb $visible={visible} $length={nav.children.length}>
            { render }
          </Lnb>
        ) : (
          <Popover
            target={`#${nav.id}`}
            visible={visible}
            hideOnOutsideClick={true}
            onHiding={() => setVisible(false)}
            position='right'
            wrapperAttr={{class: 'nav-popover'}}
          >
            { render }
          </Popover>
        )
      )}
    </>
  );
});